/*
 * Öffnet die Modalbox mit dem EU-Gewährleistungslabel auch aus Links heraus,
 * die kein modal-opener sein können — etwa Einträgen einer Shopify-
 * Navigation im Footer oder in der Kopfzeile.
 *
 * Greift auf jedes Element mit data-legal-guarantee und zusätzlich auf Links,
 * die auf den Anker #gesetzliche-gewaehrleistung zeigen oder auf die in den
 * Theme-Einstellungen hinterlegte Gewährleistungs-Seite.
 *
 * Ohne JavaScript bleibt der Link ein gewöhnlicher Link auf diese Seite, die
 * Mitteilung ist also weiterhin mit einem Klick erreichbar.
 */
(() => {
  const MODAL_ID = 'LegalGuaranteeModal';
  const HASHES = ['#gesetzliche-gewaehrleistung', '#legal-guarantee'];

  const normalize = (path) => (path || '').toLowerCase().replace(/\/+$/, '');

  const pagePath = () => {
    const modal = document.getElementById(MODAL_ID);
    return modal ? normalize(modal.dataset.pageUrl) : '';
  };

  const isTrigger = (link) => {
    const href = (link.getAttribute('href') || '').toLowerCase();
    if (HASHES.some((hash) => href.endsWith(hash))) return true;

    // Reine Sprungmarken zeigen auf den eigenen Pfad und würden sonst auf der
    // Gewährleistungs-Seite selbst fälschlich als Auslöser gelten.
    if (href.startsWith('#')) return false;

    // Menü-Links auf die Gewährleistungs-Seite — inklusive Sprach-Präfix wie /de/pages/…
    const page = pagePath();
    if (!page) return false;

    const path = normalize(link.pathname);
    return path === page || path.endsWith(page);
  };

  // Liegt der Link in einem offenen Menü oder einer anderen Modalbox, muss das
  // erst schließen, sonst überlagern sich Fokusfalle und Scroll-Sperre.
  const closeSurrounding = (event, link) => {
    const drawer = link.closest('header-drawer, menu-drawer');
    const details = drawer && drawer.mainDetailsToggle;
    if (details && details.hasAttribute('open')) {
      drawer.closeMenuDrawer(event, details.querySelector('summary'));
    }

    const dialog = link.closest('modal-dialog[open]');
    if (dialog && dialog.id !== MODAL_ID && typeof dialog.hide === 'function') {
      dialog.hide();
    }
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest) return;

    // data-legal-guarantee wirkt auf jedem Element, damit der Auslöser auch aus
    // einem Custom-Liquid-Block heraus funktioniert und nicht nur als Link.
    const trigger = event.target.closest('[data-legal-guarantee]');
    const link = trigger || event.target.closest('a[href]');
    if (!link || (!trigger && !isTrigger(link))) return;

    const modal = document.getElementById(MODAL_ID);
    if (!modal || typeof modal.show !== 'function') return;

    event.preventDefault();
    closeSurrounding(event, link);
    modal.show(link);
  }, true);
})();
